import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  product: string;
  price: string;
  time: string;
}
const purchases: Purchase[] = [{
  name: 'Rachel K.',
  location: 'Houston, TX',
  product: 'Digital Edition',
  price: '$131',
  time: '2 min ago'
}, {
  name: 'James M.',
  location: 'London, UK',
  product: 'Digital Edition',
  price: '$57',
  time: '5 min ago'
}, {
  name: 'Sofia L.',
  location: 'Miami, FL',
  product: 'Awakening Pack',
  price: '$97',
  time: '8 min ago'
}, {
  name: 'Carlos R.',
  location: 'Madrid, ES',
  product: 'Digital Edition',
  price: '$57',
  time: '3 min ago'
}, {
  name: 'Anna T.',
  location: 'Sydney, AU',
  product: 'Awakening Pack',
  price: '$97',
  time: '1 min ago'
}, {
  name: 'Mike D.',
  location: 'New York, NY',
  product: 'Digital Edition',
  price: '$57',
  time: '7 min ago'
}, {
  name: 'Priya S.',
  location: 'Toronto, CA',
  product: 'Digital Edition',
  price: '$131',
  time: '4 min ago'
}];
export function RecentPurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const firstTimer = setTimeout(() => {
      setVisible(true);
    }, 4000);
    return () => clearTimeout(firstTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextTimer = setTimeout(() => {
        if (!dismissed) {
          setCurrentIdx(prev => (prev + 1) % purchases.length);
          setVisible(true);
        }
      }, 8000);
      return () => clearTimeout(nextTimer);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  const purchase = purchases[currentIdx];
  return <div className="fixed bottom-6 left-4 sm:left-6 z-50 transition-all duration-700 ease-in-out" style={{
    transform: visible ? 'translateY(0)' : 'translateY(6rem)',
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? 'auto' : 'none'
  }} data-id="element-40">
      <div className="flex items-center gap-3 bg-gray-900/95 backdrop-blur-md border border-green-500/30 rounded-xl p-3 shadow-2xl max-w-xs sm:max-w-sm" data-id="element-41">

        {/* Imagen portada */}
        <div className="shrink-0 w-12 h-16 rounded-lg overflow-hidden border border-green-500/20" data-id="element-42">
          <img src="https://res.cloudinary.com/dab9nhevk/image/upload/q_auto,f_auto,w_600/v1772492269/thumb_pqxclw.jpg" alt="Book cover" className="w-full h-full object-cover" data-id="element-43" />
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0" data-id="element-44">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-45">
            <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse shrink-0" data-id="element-46" />
            <span className="text-green-400 text-xs font-bold uppercase tracking-wide" data-id="element-47">
              Recent Purchase
            </span>
          </div>
          <p className="text-white text-xs sm:text-sm font-bold truncate" data-id="element-48">
            <span className="text-green-400" data-id="element-49">{purchase.name}</span>
            {' '}from {purchase.location}
          </p>
          <p className="text-gray-400 text-xs mt-0.5" data-id="element-50">
            {purchase.product}{' '}
            <span className="text-yellow-400 font-bold" data-id="element-51">• {purchase.price}</span>
          </p>
          <p className="text-gray-600 text-xs mt-0.5" data-id="element-52">{purchase.time}</p>
        </div>

        {/* Botón cerrar */}
        <button onClick={() => {
        setVisible(false);
        // Vuelve a aparecer después de 6 segundos
        setTimeout(() => {
          setCurrentIdx(prev => (prev + 1) % purchases.length);
          setVisible(true);
        }, 6000);
      }} className="shrink-0 text-gray-500 hover:text-white transition-colors p-1 rounded-full hover:bg-white/10" data-id="element-53">
          <X size={14} data-id="element-54" />
        </button>
      </div>
    </div>;
}